import Connect from '../Apis/Connect'
import Controller from './Controller'

export default class ConnectController extends Controller {
  constructor() {
    super(new Connect())
  }
  async preRequisite(){
    const data= await this.model.preRequisite();
    return data;
    
  }
}
